export var fileTypes = {
  INVOICE: 'invoice',
  PAYMENT_PROOF: 'payment_proof',
  DUNS_CERT: 'duns_certificate',
  ID_FRONT: 'personal_id_front',
  ID_BACK: 'personal_id_back',
  TAX: 'tax',
  LAST_BALANCE: 'last_balance',
  DATE_BALANCE: 'date_balance',
  TAX_REGISTRATION_FORM: 'tax_registration_form',
  CONSTITUTIVE_ACT_COMPANY: 'constitutive_act_company'
};